module.exports = __webpack_public_path__ + "static/media/portfolio (17).0e6315b1.jpg";